// src/render/scenes/BootScene.ts — preload Mouchao tilemap + tileset (MAP-01)
// + light-mask glow placeholder PNGs (P2 VIS-02/06), then hand off to GameScene.
//
// Phaser 4 ESM has NO default export (Pitfall 2): namespace import only.
// Source: Phase 1 RESEARCH.md §Pattern 1, PATTERNS.md §BootScene.ts modification,
//         Phase 2 PATTERNS.md §BootScene.ts MODIFIED.

import * as Phaser from 'phaser';

import {
  PERMANENT_GLOW_TEXTURE_KEY,
  MOTION_GLOW_TEXTURE_KEY,
  TORCH_CONE_TEXTURE_KEY,
} from '../lighting/torch-cone';

export class BootScene extends Phaser.Scene {
  constructor() {
    super('BootScene');
  }

  preload(): void {
    // Tileset PNG (32×32 placeholder; hand-drawn in P6).
    this.load.image('mouchao-tileset', 'assets/maps/mouchao-tileset.png');
    // Tiled JSON map (v1.10+, CSV / uncompressed tile encoding).
    this.load.tilemapTiledJSON('mouchao', 'assets/maps/mouchao.tmj');

    // P2 D-12: placeholder warm-amber glow sprites for the LightMask. Generated
    // by scripts/generate-placeholder-light-sprites.mjs; swapped at runtime via
    // LIGHT_ATLAS_REGISTRY in P6. Each PNG <10 KB (total <30 KB per UI-SPEC).
    this.load.image(PERMANENT_GLOW_TEXTURE_KEY, 'assets/lights/permanent-glow.png');
    this.load.image(MOTION_GLOW_TEXTURE_KEY, 'assets/lights/motion-glow.png');
    this.load.image(TORCH_CONE_TEXTURE_KEY, 'assets/lights/torch-cone.png');

    // P4 Plan 04-04 (D-11): awareness telegraph placeholder SVGs. Generated by
    // scripts/generate-placeholder-icons.mjs; swapped for real art in Phase 7.
    this.load.image('telegraph-suspicious', 'assets/icons/telegraph-suspicious.svg');
    this.load.image('telegraph-alerted', 'assets/icons/telegraph-alerted.svg');
    this.load.image('telegraph-spotted', 'assets/icons/telegraph-spotted.svg');
  }

  create(): void {
    this.scene.start('GameScene');
  }
}
